module.exports = __webpack_public_path__ + "img/keys_on_hands.2a98cbcd.png";